import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faCheck, faArrowRight, faBuilding } from '@fortawesome/free-solid-svg-icons';
import '../css/AuroraBackground.css';
import '../css/LoginLocation.css';

const LoginLocation = () => {

  const [selectedRows, setSelectedRows] = useState([]);

  const handleCheckboxChange = (index, item) => {
    console.log('Selected Rows:', item);
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter((selectedRow) => selectedRow !== index));
    } else {
      setSelectedRows([...selectedRows, index]);
    }
  }

  const userData = useSelector((state) => state.user.user);
  console.log('userData:', userData);

  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/Billingdasboard')
  }

  const locIdentifiers = userData?.LocIdentifiers || [];

  useEffect(() => {
    // Check if LocIdentifiers has more than one value
    if (locIdentifiers.length == 0) {
      navigate('/Billingdasboard');
    }
  }, [locIdentifiers, navigate]);

  // Remove "A$" prefix
  const displayIdentifiers = locIdentifiers.map(loc => loc.split('$')[1]);

  useEffect(() => {
    // Initialize selectedRows with all indices
    const allIndices = displayIdentifiers.map((_, index) => index);
    setSelectedRows(allIndices);
  }, []);

  const allSelected = displayIdentifiers.length > 0 && selectedRows.length === displayIdentifiers.length;

  const toggleSelectAll = () => {
    if (allSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(displayIdentifiers.map((_, index) => index));
    }
  };

  return (
    <div className='ll-screen aurora-bg'>
      <div className='ll-card'>

        <div className='ll-head'>
          <div className='ll-head-icon'>
            <FontAwesomeIcon icon={faLocationDot} />
          </div>
          <h1>Select Location</h1>
          <p>Choose the locations you want to work with</p>
        </div>

        <div className='ll-body'>
          <div className='ll-toolbar'>
            <span className='ll-count'>
              <strong>{selectedRows.length}</strong> of {displayIdentifiers.length} selected
            </span>
            <button type='button' className='ll-selectall' onClick={toggleSelectAll}>
              {allSelected ? 'Clear all' : 'Select all'}
            </button>
          </div>

          <div className='ll-list'>
            {displayIdentifiers.length > 0 ? (
              displayIdentifiers.map((identifier, index) => {
                const selected = selectedRows.includes(index);
                return (
                  <div
                    key={index}
                    className={`ll-item ${selected ? 'is-selected' : ''}`}
                    onClick={() => handleCheckboxChange(index, identifier)}
                    role='checkbox'
                    aria-checked={selected}
                    tabIndex={0}
                    onKeyDown={(e) => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); handleCheckboxChange(index, identifier); } }}
                  >
                    <span className='ll-item-icon'>
                      <FontAwesomeIcon icon={faBuilding} />
                    </span>
                    <span className='ll-item-label'>{identifier}</span>
                    <span className='ll-check'>
                      <FontAwesomeIcon icon={faCheck} />
                    </span>
                  </div>
                );
              })
            ) : (
              <div className='ll-empty'>No locations available</div>
            )}
          </div>

          <div className='ll-foot'>
            <button
              type='button'
              className='ll-continue'
              onClick={handleHomeClick}
              disabled={selectedRows.length === 0}
            >
              Continue
              <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </div>
        </div>

      </div>
    </div>
  )
}

export default LoginLocation
